'use client';

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getCookie, hasCookie } from 'cookies-next';
import { client } from '@/api/client';
import { ProfileDTO, UserDTO } from '@/types/models';
const _mapperProfileToUser = (data: ProfileDTO): UserDTO => {
  const item = {
    companyName: data.company_name,
    companyNationalId: data.company_national_id,
    userName: '',
    userInitial: (data?.legal_type === 'legal' ? data.company_name?.slice(0, 1) : data.first_name.slice(0, 1)) || '',
    firstName: data.first_name,
    lastName: data.last_name,
    nationalId: data.national_id,
    phone: data.phone,
    email: data.email,
    accountNumber: '',
    isSejamVerified: data.is_sejam_verified,
    exchangeCode: data.exchange_code,
    faraboorsCode: data.faraboors_code && data.faraboors_code !== 'undefined' ? data.faraboors_code : '',
    legalType: data.legal_type,
    birth_date: data.birth_date,
    can_show_info: data.can_show_info,
    bankAccounts: data.bankAccounts,
    is_profile_completed: data.is_profile_completed,
    referral_code: data.referral_code
  };
  return item;
};
export async function getProfile(): Promise<UserDTO | undefined> {
  if (hasCookie('access_token')) {
    const res = await client.get('/profile');
    return _mapperProfileToUser(res?.data?.data);
  }
  return undefined;
}
export function useProfile(): UseQueryResult<UserDTO | undefined, Error> {
  return useQuery({
    queryFn: () => getProfile(),
    queryKey: ['profile'],
    enabled: !!getCookie('access_token')
  });
}